export const ieo = {
  zzjx: 'En cours',
  rgjl: 'Historique de subscription',
  yjjs: 'Terminé',
  sf: 'Lancement',
  mjze: 'Montant total collecté',
  ckjz: 'Progression du financement',
  tips_1: 'Biking Startup est lancé ! Découvrez le code de la richesse avec Biking !',
  tips_2: 'De bons projets arrivent bientôt, restez à l\'écoute',
  jyjjks: 'Le trading commence bientôt',
  ksjy: 'Commencer le trading',
  qjy: 'Aller trader',
  xmmc: 'Nom du projet',
  xmfjs: 'Présentation du projet',
  syxm: 'Tous les projets',
  banner_1: 'Nouvelle plateforme de lancement de projets blockchain',
  banner_2: 'Trouvez le cheval noir de la blockchain avec Biking et lancez-vous vers la liberté financière',
  ywc: 'Terminé',
  rgsj: 'Période de subscription :',
  zcz: 'Soutiens',
  dqjd: 'Progression actuelle',
  yck: 'Collecté',
  sddb: 'Jetons reçus',
  dff: 'En attente de distribution',
  zwxm: 'Aucun projet',
  xq: 'Détails',
  wksyr: 'Pas encore de préchauffage',
  yrz: 'En préchauffage',
  jxz: 'En cours',
  yjs: 'Terminé',
  ts: 'Astuce',
  dbwfjy: 'Ce jeton n\'est pas tradable pour le moment',
  ckqtdb: 'Veuillez consulter d\'autres jetons',
  xm: 'Projet',
  ksrg: 'Commencer la subscription',
  yrg: 'Souscrit',
  xmjs: 'Présentation du projet',
  csjg: 'Prix initial',
  dbzl: 'Offre totale : {amount} jetons',
  cssz: 'Capitalisation initiale : {fdv} USD',
  xmcytj: 'Conditions de participation',
  cjygzh: 'Créer un compte Biking',
  yyzh: 'Déjà un compte, se connecter directement',
  dlzhjkcy: 'Connectez-vous pour participer',
  dljkrg: 'Connectez-vous pour vous abonner',
  xhzc: 'Actifs spot',
  zcdy: 'Actifs spot ≥ 10 USDT',
  rggz: 'Règles de subscription',
  rgcg: 'Subscription réussie',
  cgrgxm: 'Félicitations ! Vous avez souscrit avec succès au projet !',
  fhsy: 'Retour à l\'accueil',
  cyrghd: 'Participer à l\'activité de subscription Biking Startup',
  rgje: 'Montant de la subscription',
  xhzcgz: 'Évaluation des actifs spot',
  rgsm: 'Instructions de subscription :',
  rgsm1: '1. Le montant de subscription personnel est de ≥{amount1}USDT et ≤{amount2}USDT ;',
  rgsm2: '2. Le projet distribute les jetons au prorata des fonds investis. Si le montant souscrit est supérieur au montant réel分配, le reste sera remboursé.',
  qd: 'Confirmer',
  dyr: 'En attente de préchauffage',
  rgdjs: 'Compte à rebours de la subscription',
  yrdjs: "Compte à rebours du préchauffage",
  jykqdjs: 'Compte à rebours avant l\'ouverture du trading',
  qrg: 'Souscrire',
  rgjebdy: 'Le montant minimum de subscription est {amount} USDT',
  rgjebgy: 'Le montant maximum de subscription est {amount} USDT',
  rgjeccdqjc: 'Le montant de subscription dépasse les actifs actuels',
  fxts1: "1. Les projets	startups sont encore à un stade précoce. L'exploitation du projet, la technologie sous-jacente et l'environnement juridique comportent tous des risques importants.",
  fxts2: "2. Comprendre les Tokens et évaluer leurs risques inhérents nécessite des connaissances techniques et financières avancées.",
  fxts3: "3. Sous l'effet de la technologie, des lois, du marché et d'autres facteurs, le prix du Token que vous achetez peut波动 fortement.",
  fxts4: "4. En raison de la technologie sous-jacente du Token ou de la plateforme Biking, le Token acheté peut ne pas pouvoir être retiré en totalidad ou en partie.",
  sfpt: "Plateforme de lancement de projets blockchain",
  xmhzsq: "Demande de partenariat projet",
  hdlx: "Type d'activité",
  yryq: "Un token par personne",
  yrdq: "Multiples tokens par personne",
  hdjg: "Prix de l'activité",
  hdsl: "Quantité de l'activité",
  zqs: "Total des tokens",
  rgqs: "Tokens souscrits",
  rgsl: "Quantité souscrite",
  mqsl: "Quantité par token",
  mrzgqs: "Maximum par personne",
  qian: "token",
  lian: "chaîne",
  hdrgsm: "Instructions : Après l'attribution, la subscription est aléatoire. En cas d'échec, les USDT utilisées seront remboursées.",
  jqqd: "Attendez les résultats de l'attribution",
  dbffkjy: "Le jeton peut être tradé après distribution",
  dzjgb: "En attente de publication",
  dzq: "En attente d'attribution",
  ffzt: "Statut de distribution",
  dbff: "Distribution des jetons attribués",
  yff: "Distribué",
  wzq: "Non attribué",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/ieo/fr.js